import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import { createStore } from 'redux';
import { rootReducer } from './rootReducer';
var composeEnhancer = composeWithDevToolsDevelopmentOnly({
    trace: true,
    traceLimit: 25
});
export var configuredStore = function configuredStore() {
    var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return createStore(rootReducer(), initialState, composeEnhancer());
};
